import { default as UUID } from "node-uuid"
import { SCALAR_TYPES } from "src/libs/scalars"
import { CARD_FIELD_TYPE, CardFiled, ICard, ILandingSection, LANDING_TYPE_CONTENT, PersonalFields, PersonsContent } from "src/modules/pe-landing-module/data/interfaces"
import Cards from "./Cards"
import Dummy from "./Dummy"
import personal_cards from "src/modules/pe-landing-module/data/utils/personal_cards"
import useCardFieldsOrder from "src/modules/pe-landing-module/hooks/useCardFieldsOrder"

/* Protopia Ecosystem component */
export interface IPersonsProps {
   section:ILandingSection
   data: PersonsContent
} 

// Dictionary for used card fields type 
export const PersonsFieldType  = ( ): any => { 
    return {
        empty: CARD_FIELD_TYPE.EMPTY,
        canvas: CARD_FIELD_TYPE.CANVAS,
        avatar : CARD_FIELD_TYPE.IMAGE,
        background : CARD_FIELD_TYPE.IMAGE,
        avatarMedallion :CARD_FIELD_TYPE.MEDALLION,
        last_name : SCALAR_TYPES.TITLE,
        person : CARD_FIELD_TYPE.PERSON,
        first_name : SCALAR_TYPES.HTML,
        display_name : SCALAR_TYPES.HTML,
        roles: SCALAR_TYPES.TAGS,
        description : SCALAR_TYPES.HTML,
        links : CARD_FIELD_TYPE.PERSONAL_LINKS,
        divider : CARD_FIELD_TYPE.DIVIDER,
        statistic_line: CARD_FIELD_TYPE.STATISTIC_LINE, 
        order : CARD_FIELD_TYPE.ORDER,
    }
}

const Persons = (props: IPersonsProps): JSX.Element => {
    const template = !!props.data.design_type
        ?
        personal_cards()[ props.data.design_type - 1 ]
        :
        {}
    
    
    const data: PersonsContent = {
        ...template, 
        ...props.data,
    }
    
    const { section } = props
    const { cards, card_fields } = data
    const order: (keyof PersonalFields)[] = useCardFieldsOrder( data.order, card_fields) as (keyof PersonalFields)[]
    
    const getCardFields = ( card_fields: PersonalFields ) : CardFiled[] => {
        let arr: any[] = order.map((key: keyof PersonalFields) => { 
            const field: CardFiled = {
                id: UUID.v4(),
                ...card_fields[key],
                type: PersonsFieldType( )[key],
                pseudonym: key,
            }
            return field
        })
        return arr
    }
    const getCards = (): ICard[] => {
        let arr: [] = cards.map(( card: any, i:number ) => {
            return {
                i,
                ...card,
                value: order.map((o, ii) => {
                    let value = card[o]
                    if( o === "display_name" && !value ) {

                        value = {
                            data: `${card.first_name?.data} ${card.last_name?.data}` 
                        }
                    }
                    return {
                        id: o + "-" + i + "-" + ii,
                        ...value
                    }
                })
            }
        })
        return arr
    }
    const getData = ( card_fields: PersonalFields ): any => {
        const personalLinkType: any = {
            ...data,
            card_fields: getCardFields( card_fields ),
            cards: getCards()
        }
        return personalLinkType
    }

    return !!Object.keys(order).length
        ?
        <Cards 
            section={section}
            data={ getData( card_fields || {} ) }
        />
        :
        <Dummy {...{ 
            ...{
                data: {
                    ...data as any, 
                    type: LANDING_TYPE_CONTENT.PERSONAL_CARDS, 
                    className: ` ${data.className} landing-html-${props.section.id} `
            },
            }, 
            ...props as any
        }} />
}
export default Persons